import React, { useState } from "react";
import "./ViewPostCommentForm.css";
import image_upload_icon from "../assets/image_upload_icon.png";
import gif_upload_icon from "../assets/gif_upload_icon.png";
import file_upload_icon from "../assets/file_upload_icon.png";
import translations from "./translation.js";

// CommentForm is a functional component that takes parent, loadPosts, and loadComments as props
const CommentForm = ({
  parent, // ID of the parent post to which the comment belongs
  loadPosts, // Function to reload posts
  loadComments, // Function to reload comments
}) => {
  // useState to manage the post text
  const [postText, setPostText] = useState("");
  // useState to manage the status message after posting
  const [postMessage, setPostMessage] = useState("");
  const [error, setError] = useState("");
  const [file, setFile] = useState(null);
  const [fileURL, setfileURL] = useState("");
  const currentLanguage = localStorage.getItem("selectedLanguage") || "en";
  // Function to handle form submission by making a POST request
  // to the server to add the comment to a post with a given parentID
  // which is passed in from props
  const submitHandler = (event) => {
    // Keep the form from actually submitting
    event.preventDefault();

    if (!postText.trim()) {
        setError(translations[currentLanguage].comment_error2);
        setTimeout(() => {
          setError("");
        }, 3000);
        return; // Exit the function if postText is empty
      }

    // submit the comment as a post, with the parentID being the parent that is passed
    // in through props in Post.jsx
    fetch(process.env.REACT_APP_API_PATH + "/posts", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify({
        authorID: sessionStorage.getItem("user"),
        content: postText,
        parentID: parent,
        thumbnailURL: "",
        type: "post",
        attributes: { 
          fileURL: fileURL
        },
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          
            loadPosts();
            loadComments();
            setPostText("");
            setFile(null);
            setPostMessage(translations[currentLanguage].comment_success);
            setTimeout(setPostMessage, 3000, "");
          
        },
        (error) => {
          setError(translations[currentLanguage].comment_error1);
          alert("error!");
        }
      );
  };
  const uploadFile = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    const formData = new FormData();

    formData.append("uploaderID", sessionStorage.getItem("user"));
    formData.append("attributes", JSON.stringify({}));
    formData.append("file", file);

    // make api call to file-uploads endpoint to post the profile picture
    fetch(process.env.REACT_APP_API_PATH + "/file-uploads", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        let file_URL = "https://webdev.cse.buffalo.edu" + result.path;
        setfileURL(file_URL);
      });
  };

  const handleImageUpload = (event) => {
    setFile(event.target.files[0]);
    uploadFile(event);
  };

  const handleFileUpload = (event) => {
    setFile(event.target.files[0]);
    uploadFile(event);
  };

  const handleGifUpload = (event) => {
    setFile(event.target.files[0]);
    uploadFile(event);
  };

  return (
    <div>
      <form onSubmit={submitHandler} className="VPCF">
          <br />
          <textarea autofocus="true" className="VPCF_textarea"
            rows="10"
            cols="70"
            value={postText}
            placeholder= {translations[currentLanguage].comment_text}
            onChange={(e) => setPostText(e.target.value)}
          />
        <br />
        <div className="VPCF_img_wrapper">
            {/* Upload Image Button */}
            <label htmlFor="imageUpload"> 
            <img  className="VPCF_img_wrapper_image_icon" src={image_upload_icon} alt="Upload Image" />
            </label>
            <input id="imageUpload" type="file" accept="image/*" onChange={handleImageUpload} style={{ display: 'none' }} />

            {/* Upload GIF Button */}
            <label htmlFor="gifUpload">
            <img className="VPCF_img_wrapper_gif_icons" src={gif_upload_icon} alt="Upload Image"/>
            </label>
            <input id="gifUpload" type="file" accept="image/gif" onChange={handleGifUpload} style={{ display: 'none' }} />


            {/* Upload File Button */}
            <label htmlFor="fileUpload">
            <img className="VPCF_img_wrapper_file_icons" src={file_upload_icon} alt="Upload Image" />
            </label>
            <input id="fileUpload" type="file" accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" onChange={handleFileUpload} style={{ display: 'none' }} />
            <input className="VPCF_post_button_" type="submit" value={translations[currentLanguage].post} />
        </div>
        {/* Display uploaded files */}
        {file && <p className="PostFormPage_file_name">{translations[currentLanguage].file} {file.name}</p>}
        {postMessage && (
          <div className="VPCF_post_message">{postMessage}</div>
        )}
        {error && (
          <div className="VPCF_error">{error}</div>
        )}
      </form>
    </div>
  );
};

export default CommentForm;
